import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Search } from 'lucide-react';
import { WhatsappLogo } from '@phosphor-icons/react';

const OrderTracking = () => {
  return (
    <div className="pb-16 bg-brand-bone min-h-screen" data-testid="order-tracking-page">
      {/* Hero */}
      <section className="bg-brand-black/[0.03] py-12 md:py-20 border-b border-brand-cobalt/10">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-sm text-brand-cobalt hover:text-brand-cobalt/80 mb-6"
          >
            <ArrowLeft size={16} />
            Volver al inicio
          </Link>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight mb-4 text-brand-black">
            Seguimiento de Pedido
          </h1>
          <p className="text-brand-black/60 text-lg">
            Rastrea el estado de tu compra
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-2xl mx-auto px-4">
          {/* WhatsApp Method - Primary */}
          <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-6 mb-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-green-500 rounded-full text-white">
                <WhatsappLogo size={24} weight="fill" />
              </div>
              <h2 className="font-display text-xl text-brand-black">Consulta por WhatsApp</h2>
            </div>
            <p className="text-brand-black/80 mb-4">
              La forma más rápida de conocer el estado de tu pedido es contactarnos por WhatsApp 
              con tu <strong className="text-brand-black">número de orden</strong>.
            </p>
            <a 
              href="https://wa.me/1234567890?text=Hola,%20quiero%20conocer%20el%20estado%20de%20mi%20pedido.%20Mi%20número%20de%20orden%20es:%20"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition-colors"
            >
              <WhatsappLogo size={20} weight="fill" />
              Consultar por WhatsApp
            </a>
          </div>

          {/* Info */}
          <div className="brand-card hybrid-glow p-6 rounded-lg mb-8">
            <h3 className="font-display text-lg mb-4 text-brand-black">¿Dónde encuentro mi número de orden?</h3>
            <p className="text-brand-black/70 text-sm mb-4">
              Tu número de orden se encuentra en el correo de confirmación que recibiste al realizar tu compra. 
              Tiene un formato similar a: <code className="bg-brand-black/[0.03] px-2 py-1 rounded text-xs text-brand-cobalt">ORD-XXXXXX</code>
            </p>
          </div>

          {/* Tracking Form Placeholder */}
          <div className="brand-card hybrid-glow p-6 rounded-lg">
            <h3 className="font-display text-lg mb-4 text-brand-black">Rastrear pedido</h3>
            <div className="flex gap-2">
              <input 
                type="text" 
                placeholder="Ingresa tu número de orden"
                className="flex-1 px-4 py-3 bg-brand-black/[0.03] border border-brand-cobalt/30 rounded-lg text-brand-black placeholder-brand-black/40 focus:outline-none focus:border-brand-cobalt"
                disabled
              />
              <button 
                className="px-6 py-3 bg-brand-black/[0.03] border border-brand-cobalt/30 text-brand-black/50 rounded-lg cursor-not-allowed"
                disabled
              >
                <Search size={20} />
              </button>
            </div>
            <p className="text-xs text-brand-black/50 mt-2">
              * Próximamente podrás rastrear tu pedido directamente desde aquí
            </p>
          </div>

          {/* FAQ Link */}
          <div className="mt-8 text-center">
            <p className="text-brand-black/60 mb-2">¿Tienes más preguntas?</p>
            <Link to="/faq" className="text-brand-cobalt hover:underline">
              Visita nuestras Preguntas Frecuentes →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OrderTracking;
